import React from "react";

/** Simple centered dialog used by the billing-info and full-trial forms. */
export default function ModalShell({ title, description, onClose, children, labelledBy = "modal-shell-title" }) {
  React.useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape" && onClose) onClose(); };
    window.addEventListener("keydown", onKey);
    const previous = document.body.style.overflow;
    document.body.style.overflow = "hidden";
    return () => {
      window.removeEventListener("keydown", onKey);
      document.body.style.overflow = previous;
    };
  }, [onClose]);

  return (
    <div style={overlay} role="presentation">
      <div style={dialog} role="dialog" aria-modal="true" aria-labelledby={labelledBy}>
        <h3 id={labelledBy} style={heading}>{title}</h3>
        {description && <p style={desc}>{description}</p>}
        {children}
      </div>
    </div>
  );
}

const overlay = {
  position: "fixed",
  inset: 0,
  backgroundColor: "rgba(0,0,0,0.6)",
  display: "flex",
  justifyContent: "center",
  alignItems: "flex-start",
  overflowY: "auto",
  padding: "40px 16px",
  zIndex: 9999,
};

const dialog = {
  backgroundColor: "#ffffff",
  color: "#111827",
  padding: "28px",
  borderRadius: 10,
  width: 520,
  maxWidth: "100%",
  boxShadow: "0 10px 30px rgba(0,0,0,0.3)",
  boxSizing: "border-box",
};

const heading = { margin: "0 0 8px", fontSize: 22, lineHeight: 1.4, color: "#111827" };
const desc = { margin: "0 0 18px", fontSize: 14, color: "#4b5563", lineHeight: 1.6 };
